import { type ApiResponse, newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";
import type { ApiRelProdutorFaixaLitragem } from "../types/ApiRelProdutorFaixaLitragem";

export function apiRelProdutorFaixaLitragem({ params }: { params: ApiRelatorioGetParams }): Promise<ApiResponse<ApiRelProdutorFaixaLitragem>> {
	return newRequest({
		url: "Relatorio/ProdutorFaixaLitragem",
		type: "get",
		idpk: undefined,
		params,
	});
}
